import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import Avtar from 'assets/images/Dashboard/avtar.png';
import Provider from 'assets/images/sidebar/ProviderColor.png';
import CustomPopover from 'components/common/CustomPopover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { superAdminAppointmentsDetails } from 'routes/AppUrls';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { getAppointmentCallAPI } from 'store/SuperAdmin/getAppointmentList/action';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '@mui/material/Pagination';
import moment from 'moment';
import ReusableButton from 'components/common/Button';
import { cancelAppointmentSuperAdminCallAPI } from 'store/SuperAdmin/cancelAppointment/action';
import Lottie from 'lottie-react';
import animationData from 'assets/Lottie/no_data.json';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import InputAdornment from '@mui/material/InputAdornment';
import searchIcon from 'assets/images/navbar/search.svg';
import SelectInput from 'components/common/Input/SelectInput';
import crossIcon from 'assets/images/provider/crossIcon.png';
import { DateRangePicker } from 'react-date-range';
import { addDays } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main style
import 'react-date-range/dist/theme/default.css'; // theme css
import CommonModal from 'components/common/Modal';
import { Box } from '@mui/system';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CircularProgress from '@mui/material/CircularProgress';
import { getAppointmentExportCallAPI } from 'store/SuperAdmin/AppointmentExport/action';
import { getSearchAppointmentCallAPI } from 'store/SuperAdmin/searchAppointmentList/action';
import { countryCityDropdownCallAPI } from 'store/CountryCityList/action';
import { useConfirm } from 'material-ui-confirm';
import { ShimmerBox, ShimmerCircle } from 'components/common/Shimmer';

const Appointments = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewData, setViewData] = useState('');
  const confirm = useConfirm();

  const [page, setPage] = useState(1); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Items per page
  const [searchValue, setSearchValue] = useState('');
  const [selectSort, setSelectSort] = useState('');
  const [selectSortName, setSelectSortName] = useState('');
  const [selectFilter, setSelectFilter] = useState('');
  const [selectFilterName, setSelectFilterName] = useState('');
  const [selectSortOrder, setSelectSortOrder] = useState('');
  const [selectCountry, setSelectCountry] = useState('');
  const [selectCity, setSelectCity] = useState('');
  const [isModalActive, setIsModalActive] = useState(false);
  const [loading, setLoading] = useState(true);

  const appointmentListData = useSelector(
    (state) => state?.getAppointmentReducer?.data
  );
  const countryCityData = useSelector(
    (state) => state?.countryCityDropdownReducer?.data?.data
  );
  const appointmentLoading = useSelector(
    (state) => state?.getSearchAppointmentReducer?.loading
  );

  const [totalPages, setTotalPages] = useState(
    Math.ceil((appointmentListData?.count || 0) / rowsPerPage)
  );
  const [appointmentList, setAppointmentList] = useState(
    appointmentListData ? appointmentListData : []
  );

  const handlePopoverClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    setViewData(data);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const PopoverData = [
    {
      label: <FormattedMessage id="View Details" />,
      icon: (
        <VisibilityOutlinedIcon
          style={{ marginRight: '5px', marginTop: '-5px' }}
        />
      ),
      onClick: () =>
        navigate(superAdminAppointmentsDetails(locale), {
          state: { customerId: viewData?.id },
        }),
    },
    ...(viewData?.status === 'missed' ||
    viewData?.status === 'cancelled' ||
    viewData?.status === 'completed'
      ? []
      : [
          {
            label: <FormattedMessage id="Cancel" />,
            icon: (
              <DeleteOutlinedIcon
                style={{ marginRight: '5px', marginTop: '-5px' }}
              />
            ),
            onClick: () => handleCancelAppointment(viewData),
          },
        ]),
  ];

  const statusLegend = [
    {
      name: 'missed',
      text: 'Missed',
    },
    {
      name: 'completed',
      text: 'Completed',
    },
    {
      name: 'upcoming',
      text: 'Upcoming',
    },
    {
      name: 'cancelled',
      text: 'Cancelled',
    },
  ];

  const getStatusLegendColor = (status) => {
    switch (status) {
      case 'missed':
        return '#FFA500';
      case 'completed':
        return '#28A745';
      case 'upcoming':
        return '#007BFF';
      case 'cancelled':
        return '#DC3545';
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setLoading(true);
    getSearchProviderData(page, '', '', '', '', '', '', '');
    getCountryCityList();
  }, []);

  const getCountryCityList = () => {
    dispatch(countryCityDropdownCallAPI({}, { naviagte: navigate }));
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getSearchProviderData(
      value,
      searchValue,
      selectSort,
      selectSortOrder,
      selectFilter,
      selectCountry,
      selectCity,
      selectDateRange
    );
  };

  const handleSearch = (searchValues) => {
    setPage(1);
    setSearchValue(searchValues);
    if (searchValues === '') {
      getSearchProviderData(
        1,
        '',
        selectSort,
        selectSortOrder,
        selectFilter,
        selectCountry,
        selectCity,
        selectDateRange
      );
    } else {
      getSearchProviderData(
        1,
        searchValues,
        selectSort,
        selectSortOrder,
        selectFilter,
        selectCountry,
        selectCity,
        selectDateRange
      );
    }
  };

  const handleSearchClear = (name) => {
    setPage(1);
    switch (name) {
      case 'search':
        setSearchValue('');
        getSearchProviderData(
          1,
          '',
          selectSort,
          selectSortOrder,
          selectFilter,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'sort':
        setSelectSort('');
        setSelectSortName('');
        setSelectSortOrder('');
        getSearchProviderData(
          1,
          searchValue,
          '',
          '',
          selectFilter,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'filter':
        setSelectFilter('');
        setSelectFilterName('');
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          '',
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'country':
        setSelectCountry('');
        setSelectCity('');
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          '',
          '',
          selectDateRange
        );
        break;
      case 'city':
        setSelectCity('');
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          selectCountry,
          '',
          selectDateRange
        );
        break;
    }
  };

  const getSearchProviderData = (
    page,
    searchValue,
    searchSort,
    searchSortOrder,
    searchFilter,
    searchCountry,
    searchCity,
    selectDateRange
  ) => {
    let body = {
      page_size: rowsPerPage,
      page: page,
      search_text: searchValue,
      sort_by: searchSort,
      sort_order: searchSortOrder,
      status: searchFilter,
      country: searchCountry,
      city: searchCity,
      start_date: selectDateRange
        ? moment(selectDateRange?.[0]?.startDate)?.format('YYYY-MM-DD')
        : '',
      end_date: selectDateRange
        ? moment(selectDateRange?.[0]?.endDate)?.format('YYYY-MM-DD')
        : '',
    };
    dispatch(
      getSearchAppointmentCallAPI(body, {
        run: true,
        handleFunction: (res) => {
          handleSearchSuccess(res);
          setLoading(false);
        },
        navigate: navigate,
      })
    );
  };

  const handleSearchSuccess = (res) => {
    setAppointmentList(res?.data);
    setTotalPages(Math.ceil((res?.data?.count || 0) / rowsPerPage));
  };

  const getSortName = (name) => {
    switch (name) {
      case 'Customer Name (A to Z)':
        return 'name';
      case 'Customer Name (Z to A)':
        return 'name';
      case 'Provider Name (A to Z)':
        return 'provider_name';
      case 'Provider Name (Z to A)':
        return 'provider_name';
      case 'Date & Time (Newest to Oldest)':
        return 'date';
      case 'Date & Time (Oldest to Newest)':
        return 'date';
    }
  };

  const getSortOrder = (name) => {
    switch (name) {
      case 'Customer Name (A to Z)':
        return 'asc';
      case 'Customer Name (Z to A)':
        return 'desc';
      case 'Provider Name (A to Z)':
        return 'asc';
      case 'Provider Name (Z to A)':
        return 'desc';
      case 'Date & Time (Newest to Oldest)':
        return 'desc';
      case 'Date & Time (Oldest to Newest)':
        return 'asc';
    }
  };

  const getSelectFilterValue = (name) => {
    switch (name) {
      case 'Completed Appointments':
        return 'completed';
      case 'Cancelled Appointments':
        return 'cancelled';
      case 'Missed Appointments':
        return 'missed';
      case 'Upcoming Appointments':
        return 'upcoming';
    }
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setPage(1);
    switch (name) {
      case 'sort':
        setSelectSortName(value?.name);
        setSelectSort(getSortName(value?.name));
        setSelectSortOrder(getSortOrder(value?.name));
        getSearchProviderData(
          1,
          searchValue,
          getSortName(value?.name),
          getSortOrder(value?.name),
          selectFilter,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'filter':
        setSelectFilterName(value.name);
        setSelectFilter(getSelectFilterValue(value?.name));
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          getSelectFilterValue(value?.name),
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'country':
        setSelectCountry(value?.name);
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          value?.name,
          selectCity,
          selectDateRange
        );
        break;
      case 'city':
        setSelectCity(value?.name);
        getSearchProviderData(
          1,
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          selectCountry,
          value?.name,
          selectDateRange
        );
        break;
    }
  };

  const getSortListData = [
    { name: 'Customer Name (A to Z)' },
    { name: 'Customer Name (Z to A)' },
    { name: 'Provider Name (A to Z)' },
    { name: 'Provider Name (Z to A)' },
    { name: 'Date & Time (Newest to Oldest)' },
    { name: 'Date & Time (Oldest to Newest)' },
  ];

  const getFilterListData = [
    { name: 'Completed Appointments' },
    { name: 'Cancelled Appointments' },
    { name: 'Missed Appointments' },
    { name: 'Upcoming Appointments' },
  ];

  const handleClearAll = () => {
    setSearchValue('');
    setSelectSort('');
    setSelectSortName('');
    setSelectSortOrder('');
    setSelectFilter('');
    setSelectFilterName('');
    setSelectCountry('');
    setSelectCity('');
    setDateRangeState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
    ]);
    setSelectDateRange('');
    setSelectedLabel('Today');
    getSearchProviderData(page, '', '', '', '', '', '', '');
  };

  ///////////////////////////////////////////////DateRange////////////////

  const [dateRangeState, setDateRangeState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [selectedLabel, setSelectedLabel] = useState('Today');
  const [selectDateRange, setSelectDateRange] = useState('');

  const predefinedRanges = [
    {
      label: 'Today',
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
      }),
    },
    {
      label: 'Yesterday',
      range: () => {
        const yesterday = addDays(new Date(), -1);
        return { startDate: yesterday, endDate: yesterday };
      },
    },
    {
      label: 'Last 7 Days',
      range: () => ({
        startDate: addDays(new Date(), -6),
        endDate: new Date(),
      }),
    },
    {
      label: 'Last 30 Days',
      range: () => ({
        startDate: addDays(new Date(), -29),
        endDate: new Date(),
      }),
    },
    {
      label: 'This Month',
      range: () => {
        const now = new Date();
        return {
          startDate: new Date(now.getFullYear(), now.getMonth(), 1),
          endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0),
        };
      },
    },
    {
      label: 'Last Month',
      range: () => {
        const now = new Date();
        return {
          startDate: new Date(now.getFullYear(), now.getMonth() - 1, 1),
          endDate: new Date(now.getFullYear(), now.getMonth(), 0),
        };
      },
    },
  ];

  const handleCloseModel = () => {
    setIsModalActive(false);
  };

  const handleCancelAppointment = (data) => {
    confirm({
      title: 'Cancel Appointment',
      description: `Are you sure you want to Cancel Appointment?`,
      confirmationText: 'Yes',
      cancellationText: 'No',
      dialogProps: { maxWidth: 'xs' },
      confirmationButtonProps: {
        sx: {
          bgcolor: '#292D32',
          color: '#FFFFFF',
          borderRadius: '0px',
          border: '1px solid #292D32',
          '&:hover': { bgcolor: '#292D32' },
        },
      },
      cancellationButtonProps: {
        sx: {
          bgcolor: 'transparent',
          color: '#292D32',
          borderRadius: '0px',
          border: '1px solid #292D32',
        },
      },
    })
      .then(() => handleConfirmCancelAppointment(data))
      .catch(() => setAnchorEl(null));
  };

  const handleConfirmCancelAppointment = (data) => {
    dispatch(
      cancelAppointmentSuperAdminCallAPI(
        {},
        {
          id: data?.id,
          run: true,
          handleFunction: (res) =>
            getSearchProviderData(
              page,
              searchValue,
              selectSort,
              selectSortOrder,
              selectFilter,
              selectCountry,
              selectCity,
              selectDateRange
            ),
          navigate: navigate,
        }
      )
    );
  };

  ///////////////////////////////////////////////DateRange////////////////

  ////////////////////////Export//////////////////////////////////////////

  const handleExportExcel = () => {
    dispatch(
      getAppointmentExportCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleExportNewWindow(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleExportNewWindow = (res) => {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.data?.data?.length > 0) {
        exportToExcelAndOpenTab(res?.data?.data, 'AppointmentList.xls');
      }
    }
  };

  const exportToExcelAndOpenTab = (data, fileName = 'AppointmentList.xls') => {
    const headers = Object.keys(data[0]);
    const rows = data
      .map(
        (row) =>
          `<tr>${headers
            .map((h) => {
              let value = row[h];
              if (h === 'status') {
                value = value === true ? 'Active' : 'Inactive';
              } else if (h === 'provider_data') {
                value = value?.name_en || null;
              } else if (h === 'customers_data') {
                value = value?.customers_name || null;
              }
              return `<td>${value ?? ''}</td>`;
            })
            .join('')}</tr>`
      )
      .join('');

    const table = `
      <table border="1" style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr style="background-color: #f2f2f2;">
            ${headers.map((h) => `<th style="padding: 8px; text-align: left;">${h?.charAt(0).toUpperCase() + h?.slice(1)}</th>`).join('')}
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>
    `;

    const newTab = window.open('', '_blank');
    const html = `
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            body { font-family: sans-serif; padding: 20px; }
            button, a.download-link {
              padding: 8px 12px;
              margin-right: 10px;
              margin-top: 0px;
              background: #007bff;
              color: white;
              text-decoration: none;
              border: none;
              cursor: pointer;
              border-radius: 4px;
            }
          </style>
        </head>
        <body>
          
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <h2>Appointment Data</h2>
          <div>
            <a class="download-link" href="#" onclick="downloadExcel()">⬇️ Download</a>
          </div>
        </div>
      
          ${table}
          <script>
            function downloadExcel() {
              const tableHTML = document.querySelector('table').outerHTML;
              const blob = new Blob(["\\ufeff" + tableHTML], {
                type: "application/vnd.ms-excel",
              });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = "${fileName}";
              a.click();
            }
          </script>
        </body>
      </html>
    `;
    newTab.document.open();
    newTab.document.write(html);
    newTab.document.close();
  };

  ////////////////////////Export//////////////////////////////////////////

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <div className="flex justify-between items-center">
          <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
            <FormattedMessage id="Appointments" />
          </h2>

          {!loading && (
            <ReusableButton
              fullWidth={false}
              variant="contained"
              color="#F5F5F5"
              fontSize="18px"
              fontWeight="400"
              padding="12px 35px"
              bgColor="#292D32"
              fontFamily="Akkurat"
              endIcon={
                false && (
                  <CircularProgress
                    style={{
                      color: 'white',
                      width: '20px',
                      height: '20px',
                    }}
                  />
                )
              }
              onClick={() => handleExportExcel()}
            >
              <FormattedMessage id="Export to Excel" />
            </ReusableButton>
          )}
        </div>

        <Row className="p-0 mt-3">
          {loading ? (
            <Row className="gx-4">
              <Col xs={12} className="d-flex">
                {[1, 2, 3, 4]?.map((index) => (
                  <Col
                    md={12}
                    lg={4}
                    xl={4}
                    xxl={3}
                    className="bg-white p-3"
                    key={index}
                  >
                    <div>
                      <ShimmerBox height={100} width={'100%'} />
                    </div>
                  </Col>
                ))}
              </Col>
            </Row>
          ) : (
            <>
              <Col md={12} lg={4} xl={4} xxl={3}>
                <LabelWithInput
                  placeholder={intl.formatMessage({
                    id: 'Search',
                  })}
                  label={intl.formatMessage({
                    id: 'Search',
                  })}
                  name="search"
                  type="text"
                  marginLabelTop="0"
                  height="48"
                  bgColor="#FFFFFF"
                  value={searchValue}
                  onChange={(e) => handleSearch(e?.target?.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Image
                          src={searchIcon}
                          alt="icon"
                          style={{ cursor: 'pointer' }}
                        />
                        {searchValue ? (
                          <Image
                            src={crossIcon}
                            alt="icon"
                            width={18}
                            height={18}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleSearchClear('search')}
                          />
                        ) : null}
                      </InputAdornment>
                    ),
                  }}
                />
              </Col>

              <Col md={12} lg={4} xl={4} xxl={2}>
                <SelectInput
                  marginLabelTop={'0'}
                  label={intl.formatMessage({
                    id: 'Sort',
                  })}
                  placeholder={intl.formatMessage({
                    id: 'Sort',
                  })}
                  height="48"
                  name={'sort'}
                  value={selectSortName}
                  data={getSortListData ?? []}
                  onChange={(e) => handleSelectChange(e)}
                  InputProps={{
                    endAdornment: selectSortName ? (
                      <InputAdornment
                        position="end"
                        sx={{ position: 'absolute', right: 5 }}
                      >
                        <Image
                          src={crossIcon}
                          alt="icon"
                          width={18}
                          height={18}
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleSearchClear('sort')}
                        />
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Col>

              <Col md={12} lg={4} xl={4} xxl={2}>
                <SelectInput
                  marginLabelTop={'0'}
                  label={intl.formatMessage({
                    id: 'Filter',
                  })}
                  placeholder={intl.formatMessage({
                    id: 'Filter',
                  })}
                  height="48"
                  name={'filter'}
                  value={selectFilterName}
                  data={getFilterListData ?? []}
                  onChange={(e) => handleSelectChange(e)}
                  InputProps={{
                    endAdornment: selectFilterName ? (
                      <InputAdornment
                        position="end"
                        sx={{ position: 'absolute', right: 5 }}
                      >
                        <Image
                          src={crossIcon}
                          alt="icon"
                          width={18}
                          height={18}
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleSearchClear('filter')}
                        />
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Col>

              <Col md={12} lg={4} xl={4} xxl={2}>
                <SelectInput
                  marginLabelTop={'0'}
                  label={<FormattedMessage id="Country" />}
                  placeholder={intl.formatMessage({ id: 'Country' })}
                  height="48"
                  name={'country'}
                  value={selectCountry}
                  data={countryCityData}
                  onChange={(e) => handleSelectChange(e)}
                  InputProps={{
                    endAdornment: selectCountry ? (
                      <InputAdornment
                        position="end"
                        sx={{ position: 'absolute', right: 5 }}
                      >
                        <Image
                          src={crossIcon}
                          alt="icon"
                          width={18}
                          height={18}
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleSearchClear('country')}
                        />
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Col>

              <Col md={12} lg={4} xl={4} xxl={2}>
                <SelectInput
                  marginLabelTop={'0'}
                  label={<FormattedMessage id="City" />}
                  placeholder={intl.formatMessage({ id: 'City' })}
                  height="48"
                  name={'city'}
                  value={selectCity}
                  data={
                    countryCityData?.find(
                      (value) => value?.name === selectCountry
                    )?.city || []
                  }
                  onChange={(e) => handleSelectChange(e)}
                  InputProps={{
                    endAdornment: selectCity ? (
                      <InputAdornment
                        position="end"
                        sx={{ position: 'absolute', right: 5 }}
                      >
                        <Image
                          src={crossIcon}
                          alt="icon"
                          width={18}
                          height={18}
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleSearchClear('city')}
                        />
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Col>

              <Col md={12} lg={4} xl={4} xxl={1} className="mt-4">
                <ReusableButton
                  fullWidth={true}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px"
                  height="48px"
                  bgColor="#292D32"
                  fontFamily="Akkurat"
                  onClick={() => handleClearAll()}
                >
                  <FormattedMessage id="Clear All" />
                </ReusableButton>
              </Col>
            </>
          )}
        </Row>

        {!loading && (
          <Row className="p-0 mt-3">
            <Col md={12} lg={4} xl={4} xxl={3}>
              <LabelWithInput
                placeholder={intl.formatMessage({
                  id: 'Date Range Filter',
                })}
                label={intl.formatMessage({
                  id: 'Date Range Filter',
                })}
                name="dateRange"
                type="text"
                marginLabelTop="0"
                height="48"
                bgColor="#FFFFFF"
                value={
                  selectDateRange?.length > 0 &&
                  moment(selectDateRange?.[0]?.startDate).isValid() &&
                  moment(selectDateRange?.[0]?.endDate).isValid()
                    ? `${moment(selectDateRange[0].startDate).format('YYYY-MM-DD')} - ${moment(selectDateRange[0].endDate).format('YYYY-MM-DD')}`
                    : ''
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CalendarMonthIcon
                        style={{ cursor: 'pointer' }}
                        onClick={() => setIsModalActive(true)}
                      />
                      {selectDateRange ? (
                        <Image
                          src={crossIcon}
                          alt="icon"
                          width={18}
                          height={18}
                          style={{ cursor: 'pointer', marginLeft: '5px' }}
                          onClick={() => {
                            setDateRangeState([
                              {
                                startDate: new Date(),
                                endDate: new Date(),
                                key: 'selection',
                              },
                            ]);
                            setSelectDateRange('');
                            setSelectedLabel('Today');
                            getSearchProviderData(
                              1,
                              searchValue,
                              selectSort,
                              selectSortOrder,
                              selectFilter,
                              selectCountry,
                              selectCity,
                              ''
                            );
                          }}
                        />
                      ) : null}
                    </InputAdornment>
                  ),
                }}
              />
            </Col>
          </Row>
        )}

        <Row className="m-0 p-0 mt-3 bg-[#ffffff] p-2">
          {loading ? (
            <>
              <ShimmerBox height="25px" width={'20%'} />
              <div className="mt-3 p-0">
                <ShimmerBox height="20px" width={'40%'} />
              </div>
            </>
          ) : (
            <>
              <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                {'Appointment status legend'}
              </p>

              <div className="flex items-center flex-wrap gap-4 m-0 p-0 pb-3 mt-4">
                {statusLegend.map((item) => (
                  <div key={item?.name} className="flex items-center gap-2">
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{
                        backgroundColor: getStatusLegendColor(item?.name),
                      }}
                    ></div>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      {item?.text}
                    </p>
                  </div>
                ))}
              </div>
            </>
          )}
        </Row>

        <Row className="mt-3 listHeader m-0 p-0 flex items-center">
          <Col lg={1} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Booking ID" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Customer" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Provider" />
            </p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Service Location" />
            </p>
          </Col>
          <Col lg={1} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Date & Time" />
            </p>
          </Col>
          <Col lg={1} md={6} sm={12} className="text-lg-center text-start">
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Status" />
            </p>
          </Col>
          <Col lg={1} md={6} sm={12} className="text-center">
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Actions" />
            </p>
          </Col>
        </Row>

        <Row className="bc-FFFFFF m-0 p-0">
          {loading ? (
            <>
              {[1, 2, 3, 4, 5].map((item) => (
                <Row key={item} className="m-0 p-2 listAppointment">
                  <Row className="m-0 p-0 flex items-center border-l-[8px]">
                    <Col lg={1} md={6} sm={12}>
                      <ShimmerBox width="80px" height="12px" />
                    </Col>

                    <Col lg={2} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <ShimmerCircle size="40px" />
                        <div>
                          <ShimmerBox width="120px" height="12px" />
                          <ShimmerBox
                            width="100px"
                            height="12px"
                            className="mt-1"
                          />
                        </div>
                      </Stack>
                    </Col>

                    <Col lg={2} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <ShimmerCircle size="40px" />
                        <div>
                          <ShimmerBox width="120px" height="12px" />
                          <ShimmerBox
                            width="100px"
                            height="12px"
                            className="mt-1"
                          />
                        </div>
                      </Stack>
                    </Col>

                    <Col lg={4} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <ShimmerBox width="24px" height="24px" />
                        <ShimmerBox width="150px" height="14px" />
                      </Stack>
                      <ShimmerBox
                        width="200px"
                        height="12px"
                        className="mt-1"
                      />
                    </Col>

                    <Col lg={1} md={6} sm={12}>
                      <ShimmerBox width="100px" height="12px" />
                      <ShimmerBox width="80px" height="12px" className="mt-1" />
                    </Col>

                    <Col lg={1} md={6} sm={12}>
                      <ShimmerBox width="80px" height="12px" />
                    </Col>

                    <Col lg={1} md={6} sm={12} className="text-center">
                      <ShimmerBox width="24px" height="24px" />
                    </Col>
                  </Row>
                </Row>
              ))}
            </>
          ) : appointmentList?.results?.length > 0 ? (
            appointmentList.results.map((key, index) => (
              <Row className="m-0 p-2 listAppointment">
                <Row
                  className="m-0 p-0 flex items-center  border-l-[8px]"
                  style={{ borderLeftColor: getStatusLegendColor(key?.status) }}
                >
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                      {key?.booking_id}
                    </p>
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      <img
                        src={
                          key?.customers_image ? key?.customers_image : Avtar
                        }
                        alt="icon"
                        style={{
                          height: '40px',
                          width: '40px',
                          borderRadius: '50%',
                        }}
                      />
                      <div>
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat_Bold">
                          {key?.customers_data?.customers_name}
                        </p>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                          {key?.customers_data?.customers_id}
                        </p>
                      </div>
                    </Stack>
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      <img
                        src={key?.provider_image ? key?.provider_image : Avtar}
                        alt="icon"
                        style={{
                          height: '40px',
                          width: '40px',
                          borderRadius: '50%',
                        }}
                      />
                      <div>
                        <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat_Bold">
                          {key?.provider_data?.name_en}
                        </p>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                          {key?.provider_data?.provider_id}
                        </p>
                      </div>
                    </Stack>
                  </Col>

                  <Col lg={4} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      <img
                        src={Provider}
                        alt="icon"
                        style={{ height: '24px', width: '24px' }}
                      />
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                        {key?.service_location}
                      </p>
                    </Stack>
                    <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1 truncate">
                      {key?.delivery_address}
                    </p>
                  </Col>

                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                      {key?.slot_date !== null && key?.slot_date !== undefined
                        ? moment(key?.slot_date).format('DD MMM YYYY')
                        : ''}
                    </p>
                    <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                      {key?.slot_start_time !== null &&
                      key?.slot_start_time !== undefined
                        ? moment(key?.slot_start_time).format('h:mm A')
                        : ''}
                    </p>
                  </Col>

                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat text-lg-center text-start">
                      {key?.status}
                    </p>
                  </Col>

                  <Col lg={1} md={6} sm={12} className="text-center">
                    <div>
                      <MoreVertIcon
                        aria-describedby={id}
                        style={{ fill: '#3C1053', cursor: 'pointer' }}
                        onClick={(e) => handlePopoverClick(e, key)}
                      />
                      <CustomPopover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        handleClose={handlePopoverClose}
                        options={PopoverData}
                      />
                    </div>
                  </Col>
                </Row>
              </Row>
            ))
          ) : (
            <Row className="bc-FFFFFF m-0 p-50 flex justify-center items-center">
              <Lottie
                animationData={animationData}
                loop={true}
                style={{ height: '200px', width: '200px' }}
              />
            </Row>
          )}
        </Row>

        <Row className="mt-3 m-0 p-0">
          <Stack spacing={2} className="p-0">
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              variant="outlined"
              shape="rounded"
              className="d-flex justify-end"
            />
          </Stack>
        </Row>
      </Col>

      {/* DateRange Select Modal*/}
      <CommonModal
        padding={'32px 48px'}
        width={'800px'}
        modalActive={isModalActive}
        handleClose={() => handleCloseModel()}
        innerContent={
          <Box>
            <Row>
              <DateRangePicker
                ranges={dateRangeState}
                onChange={(item) => {
                  setDateRangeState([item.selection]);
                  const selected = predefinedRanges.find(
                    (range) =>
                      range.range().startDate.toDateString() ===
                        item.selection.startDate.toDateString() &&
                      range.range().endDate.toDateString() ===
                        item.selection.endDate.toDateString()
                  );
                  setSelectedLabel(selected?.label || '');
                }}
                staticRanges={predefinedRanges.map((range) => ({
                  label: range.label,
                  range: range.range,
                  isSelected() {
                    return selectedLabel === range.label;
                  },
                }))}
                inputRanges={[]}
              />

              <Stack
                direction="horizontal"
                gap={3}
                className="items-center cursor-pointer flex justify-end"
              >
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#292D32"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="transparent"
                  fontFamily="Akkurat"
                  onClick={() => {
                    setDateRangeState([
                      {
                        startDate: new Date(),
                        endDate: new Date(),
                        key: 'selection',
                      },
                    ]);
                    setSelectedLabel('Today');
                    setPage(1);
                    setSelectDateRange([
                      {
                        startDate: new Date(),
                        endDate: new Date(),
                        key: 'selection',
                      },
                    ]);
                    getSearchProviderData(
                      1,
                      searchValue,
                      selectSort,
                      selectSortOrder,
                      selectFilter,
                      selectCountry,
                      selectCity,
                      [
                        {
                          startDate: new Date(),
                          endDate: new Date(),
                          key: 'selection',
                        },
                      ]
                    );
                  }}
                >
                  <FormattedMessage id="Clear" />
                </ReusableButton>

                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="#292D32"
                  fontFamily="Akkurat"
                  onClick={() => {
                    setSelectDateRange(dateRangeState);
                    setIsModalActive(false);
                    setPage(1);
                    getSearchProviderData(
                      1,
                      searchValue,
                      selectSort,
                      selectSortOrder,
                      selectFilter,
                      selectCountry,
                      selectCity,
                      dateRangeState
                    );
                  }}
                >
                  <FormattedMessage id="Apply" />
                </ReusableButton>
              </Stack>
            </Row>
          </Box>
        }
      />
      {/* DateRange Select Modal  */}
    </Row>
  );
};

export default Appointments;
